module.exports = __webpack_public_path__ + "static/media/alternate.60a95299.jpg";